import { Box } from '@mui/material';

import HtmlContent from '@components/HtmlContent/HtmlContent';

import './style.scss';

interface IProps {
  content: string;
}

const InfoCard = ({ content }: IProps) => (
  <Box className="card">
    <HtmlContent className="info-card__content">{content}</HtmlContent>
  </Box>
);

export default InfoCard;
